module.exports = __webpack_public_path__ + "img/jacket_lime_neo_005.30052b32.jpg";